import { render, staticRenderFns } from "./AmountGroup-gt3.vue?vue&type=template&id=28829b1e&scoped=true"
import script from "./AmountGroup-gt3.vue?vue&type=script&lang=js"
export * from "./AmountGroup-gt3.vue?vue&type=script&lang=js"
import style0 from "./AmountGroup-gt3.vue?vue&type=style&index=0&id=28829b1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28829b1e",
  null
  
)

export default component.exports